<template>
  <div class="dsf-drag-view ds-control ds-no-padding">
    <div
      class="dsf-drag-view-tools"
      v-if="isDesign"
    >
      <div
        class="dsf-drag-view-tools-item"
        :class="{'active-btn':screenRatio === item}"
        v-for="item in layoutButs"
        :key="item"
        @click="screenRatio = item"
      >{{item}}</div>
    </div>
    <div
      class="dsf-layout-container"
      :class="{'dsf-layout-container__design': isDesign}"
      ref="container"
    >
      <template v-if="isLoaded">
        <div
          v-for="(item, index) in layout"
          :key="index"
          class="dsf-layout-grid"
          v-show="handleShow(index)"
          :style="{'z-index': item.zIndex}"
        >
          <div
            class="dsf-layout-grid-item"
            v-for="it in item.layout[screenRatio]"
            :key="it.i"
            :style="setGridItemStyle(it, item)"
            :slot-name="getSlotName(it, index)"
          >
            <slot :name="getSlotName(it,index)">
            </slot>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfDragGrid",
  props: {
    height: {
      type: String,
      default: "100%",
    },
    layout: {
      type: Array,
      default: () => {
        return [
          {
            layout: {
              ">=1200": [
                { x: 0, y: 0, w: 2, h: 7, i: "A" },
                { x: 2, y: 0, w: 1, h: 5, i: "B" },
                { x: 3, y: 0, w: 1, h: 5, i: "C" },
                { x: 0, y: 7, w: 1, h: 3, i: "D" },
                { x: 1, y: 7, w: 1, h: 3, i: "E" },
                { x: 2, y: 5, w: 1, h: 5, i: "F" },
                { x: 3, y: 5, w: 1, h: 5, i: "G" },
              ],
              ">=768": [
                { x: 0, y: 0, w: 4, h: 4, i: "A" },
                { x: 0, y: 4, w: 4, h: 4, i: "B" },
                { x: 0, y: 8, w: 4, h: 4, i: "C" },
                { x: 0, y: 12, w: 4, h: 4, i: "D" },
                { x: 0, y: 16, w: 4, h: 4, i: "E" },
                { x: 0, y: 20, w: 4, h: 4, i: "F" },
                { x: 0, y: 24, w: 4, h: 4, i: "G" },
              ],
              "<768": [
                { x: 0, y: 0, w: 4, h: 4, i: "A" },
                { x: 0, y: 4, w: 4, h: 4, i: "B" },
                { x: 0, y: 8, w: 4, h: 4, i: "C" },
                { x: 0, y: 12, w: 4, h: 4, i: "D" },
                { x: 0, y: 16, w: 4, h: 4, i: "E" },
                { x: 0, y: 20, w: 4, h: 4, i: "F" },
                { x: 0, y: 24, w: 4, h: 4, i: "G" },
              ],
            },
            colNum: 4,
            rowHeight: 10,
            rowHeightUnit: "%",
            margin: [0, 0],
            zIndex: 1, // css控制层级
            verticalCompact: true, // 是否紧凑
            freeDrag: false, // 自由拖动
            freeResize: false, // 自由拉伸
          },
        ];
      },
    },
    //插槽
    slots: {
      type: Array,
      default() {
        return [
          { name: "area-A-1", controls: [] },
          { name: "area-B-1", controls: [] },
          { name: "area-C-1", controls: [] },
          { name: "area-D-1", controls: [] },
          { name: "area-E-1", controls: [] },
          { name: "area-F-1", controls: [] },
          { name: "area-G-1", controls: [] },
        ];
      },
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: Array,
      default: () => [0, 0, 0, 0],
    },
    currentLevel: {
      type: Number,
      default: 1,
    },
  },
  ctrlCaption: "拖拽网格布局",
  mixins: [$mixins.layout],
  watch: {
    height: {
      handler(v) {
        if (this.isDesign) {
          let height = v;
          if (dsf.isNumber(height)) {
            height += "px";
          }
          this.$dispatch("design-height-change", height);
          this.$nextTick(() => {
            this.getContainerSize();
          });
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      containerWidth: 0,
      containerHeight: 0,
      screenRatio: ">=1200",
      layoutButs: [">=1200", ">=768", "<768"],
      isLoaded: false,
    };
  },
  mounted() {
    this.isLoaded = true;
    this.getContainerSize();
  },
  methods: {
    // 获取容器尺寸
    getContainerSize() {
      const { offsetHeight, offsetWidth } = this.$refs.container;
      this.containerWidth = offsetWidth;
      if (this.isDesign) {
        this.containerHeight = offsetHeight;
      } else {
        this.containerHeight = this.$el.parentNode.offsetHeight;
        if (offsetWidth >= 1200 && this.screenRatio !== ">=1200") {
          this.screenRatio = ">=1200";
        } else if (offsetWidth >= 768 && offsetWidth < 1200 && this.screenRatio !== ">=768") {
          this.screenRatio = ">=768";
        } else if (offsetWidth < 768 && this.screenRatio !== "<768") {
          this.screenRatio = "<768";
        }
      }
    },
    setGridItemStyle({ x, y, w, h, zIndex, penetrate, overflow }, { colNum, rowHeight, rowHeightUnit = "%", colNumUnit = "%" }) {
      const itemWidth = colNumUnit === "%" ? this.containerWidth / colNum : colNum;
      let itemHeight = 0;
      if (rowHeightUnit === "%") {
        const rate = parseFloat(rowHeight);
        itemHeight = (this.containerHeight / 100) * rate;
      } else {
        itemHeight = rowHeight;
      }
      // itemHeight = ((this.containerHeight / 100) * rowHeight).toFixed(2);
      let padding = _.map(this.padding, (item) => {
        return item === "" ? "0px" : `${parseInt(item)}px`;
      });

      return {
        width: `${w * itemWidth}px`,
        height: `${h * itemHeight}px`,
        top: `${y * itemHeight}px`,
        left: `${x * itemWidth}px`,
        padding: padding.join(" "),
        zIndex: zIndex === undefined ? 1 : zIndex,
        overflow: overflow || "hidden",
        "pointer-events": this.isDesign ? "auto" : penetrate ? "none" : "auto",
      };
    },
    getSlotName({ i }, index) {
      return `area-${i}-${index + 1}`;
    },
    handleShow(index) {
      if (this.isDesign) {
        return this.showAll ? true : index + 1 === this.currentLevel;
      } else {
        return true;
      }
    },
    resize() {
      this.getContainerSize();
    },
  },
});
</script>